import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";

export default function Verify() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [tckn, setTckn] = useState("");
  const [fullName, setFullName] = useState(user?.name || "");
  const [year, setYear] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/verify", { tckn, full_name: fullName, birth_year: Number(year) });
      await refresh();
      toast.success("Kimlik doğrulandı ✓");
      nav("/panelim");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Doğrulama başarısız");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="verify-page">
      <div className="border border-stone-200 bg-white p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-green-600 text-white flex items-center justify-center">
            <ShieldCheck size={20} weight="bold" />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.3em] font-bold text-stone-500">e-Devlet · Simülasyon</p>
            <h1 className="font-display text-2xl font-black tracking-tighter">Kimliğini Doğrula</h1>
          </div>
        </div>

        <p className="text-sm text-stone-600 mb-6 border-l-2 border-stone-900 pl-3">
          Doğrulanmış üyeler ilan açabilir ve teklif verebilir. Bilgileriniz üçüncü taraflarla paylaşılmaz.
          <span className="block mt-1 text-[10px] uppercase tracking-widest font-bold text-stone-400">
            Bu ortamda simüle edilir — gerçek TCKN çağrısı yapılmaz.
          </span>
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">TC Kimlik No</label>
            <input
              data-testid="verify-tckn"
              required
              minLength={11} maxLength={11}
              value={tckn}
              onChange={(e) => setTckn(e.target.value.replace(/\D/g, "").slice(0, 11))}
              className="w-full bg-stone-50 border border-stone-200 px-4 py-3 font-mono-tight focus:outline-none focus:border-stone-950 focus:bg-white"
              placeholder="11 haneli TCKN"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">Ad Soyad (profildeki ile aynı)</label>
            <input
              data-testid="verify-name"
              required value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="w-full bg-stone-50 border border-stone-200 px-4 py-3 focus:outline-none focus:border-stone-950 focus:bg-white"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.2em] font-bold text-stone-500 mb-2">Doğum Yılı</label>
            <input
              data-testid="verify-year"
              required type="number" min="1900" max="2010"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="w-full bg-stone-50 border border-stone-200 px-4 py-3 font-mono-tight focus:outline-none focus:border-stone-950 focus:bg-white"
            />
          </div>
          <button
            data-testid="verify-submit"
            disabled={busy}
            className="w-full bg-green-600 text-white font-bold py-3 hover:bg-green-700 transition-colors disabled:opacity-60"
          >
            {busy ? "Doğrulanıyor…" : "Kimliğimi Doğrula"}
          </button>
        </form>
      </div>
    </div>
  );
}
